import React from 'react';
import { Link } from 'react-router-dom';
import './PartnerDemoPages.css';

const DEMO_VISIBILITY = [
  { id: '1', name: 'Gulf Bank', requested: '2025-01-20', status: 'Assessment requested' },
  { id: '2', name: 'Qatar National Finance', requested: '2025-01-18', status: 'In progress' },
  { id: '3', name: 'MENA Finance Co.', requested: '2025-01-10', status: 'Completed' },
];

function getBadgeClass(status: string) {
  if (status === 'Completed') return 'badge-success';
  if (status === 'In progress') return 'badge-warning';
  return 'badge-secondary';
}

export default function DemoPartnerVisibility() {
  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Visibility</span>
      </nav>
      <header className="page-header">
       
        <p className="page-subtitle mb-0">
          Institutions that can see your profile or have requested an assessment. Manage visibility as needed.
        </p>
      </header>

      <div className="card-partner">
        <div className="card-header-partner">Institutions with access or requests</div>
        <div className="card-body-partner p-0">
          <table className="table-partner">
            <thead>
              <tr>
                <th>Institution</th>
                <th>Requested</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {DEMO_VISIBILITY.map((v) => (
                <tr key={v.id}>
                  <td><strong>{v.name}</strong></td>
                  <td>{v.requested}</td>
                  <td><span className={`badge-partner ${getBadgeClass(v.status)}`}>{v.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-3">
        <Link to="/" className="btn btn-partner-outline">Back to dashboard</Link>
      </div>
    </div>
  );
}
